import Swal from 'sweetalert2';

/**
 * @function alert
 * @description
 * Muestra una alerta personalizada utilizando SweetAlert2.
 *
 * @param {string} title - Título de la alerta.
 * @param {string} text - Mensaje de la alerta.
 * @param {('success'|'error'|'warning'|'info'|'question')} type - Tipo de ícono de alerta.
 *
 * @example
 * alert('Acción completada', 'El usuario ha sido guardado con éxito.', 'success');
 */
export const alert = (title, text, type) => {
	Swal.fire({
		title: title,
		text: text,
		icon: type,
		confirmButtonText: 'Continuar',
		showCloseButton: true,
		allowOutsideClick: false,
		allowEscapeKey: false,
		allowEnterKey: false,
		reverseButtons: true
	});
};